// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../../../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../../../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.AccountPayments_prepayBanner__U9jr6 {
  background-color: #ffb034;
  padding: 12px 16px;
  border-radius: 0px;
  display: flex;
  align-items: center;
  justify-content: left;
  color: #FFFFFF;
  font-size: 24px;
  font-weight: 300;
  line-height: 1;
  text-align: center;
  text-decoration: none;
  margin-top: 40px;
}
.AccountPayments_prepayBanner__U9jr6:hover {
  text-decoration: none !important;
  cursor: pointer;
}
.AccountPayments_prepayBanner__U9jr6 .AccountPayments_prepayText__wUxoU {
  font-style: italic;
}
.AccountPayments_prepayBanner__U9jr6 .AccountPayments_prepayText__wUxoU strong {
  font-weight: 700;
  margin-right: 2px;
}
.AccountPayments_prepayBanner__U9jr6 .AccountPayments_discountAmount__EczXg {
  margin-left: 6px;
}`, "",{"version":3,"sources":["webpack://./src/styles/Payments/AccountPayments.module.scss"],"names":[],"mappings":"AAAA;EACI,yBAAA;EACA,kBAAA;EACA,kBAAA;EACA,aAAA;EACA,mBAAA;EACA,qBAAA;EACA,cAAA;EACA,eAAA;EACA,gBAAA;EACA,cAAA;EACA,kBAAA;EACA,qBAAA;EACA,gBAAA;AACJ;AACI;EACI,gCAAA;EACA,eAAA;AACR;AAEI;EACI,kBAAA;AAAR;AAEQ;EACI,gBAAA;EACA,iBAAA;AAAZ;AAII;EACI,gBAAA;AAFR","sourcesContent":[".prepayBanner {\n    background-color: #ffb034; // Setlite token or Figma orange\n    padding: 12px 16px;\n    border-radius: 0px;\n    display: flex;\n    align-items: center;\n    justify-content: left;\n    color: #FFFFFF;\n    font-size: 24px;\n    font-weight: 300;\n    line-height: 1;\n    text-align: center;\n    text-decoration: none;\n    margin-top: 40px;\n\n    &:hover {\n        text-decoration: none !important;\n        cursor: pointer; // optional, makes it feel clickable\n    }\n\n    .prepayText {\n        font-style: italic;\n\n        strong {\n            font-weight: 700;\n            margin-right: 2px;\n        }\n    }\n\n    .discountAmount {\n        margin-left: 6px;\n    }\n}"],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {
	"prepayBanner": `AccountPayments_prepayBanner__U9jr6`,
	"prepayText": `AccountPayments_prepayText__wUxoU`,
	"discountAmount": `AccountPayments_discountAmount__EczXg`
};
export default ___CSS_LOADER_EXPORT___;
